import AdminEventTypes from './AdminEventTypes';

export default AdminEventTypes;
